import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useThemeProps, handleComponentsProp, ensureArray, DevNotice, upperCamelCase } from "@wsui/base";
import DefaultHits from "./DefaultHits.mjs";
function defaultComponentMapping(_ref) {
  let {
    searchPageType,
    contentType
  } = _ref;
  return [contentType && searchPageType && `${upperCamelCase(contentType)}${upperCamelCase(searchPageType)}Hits`, contentType && `${upperCamelCase(contentType)}Hits`, searchPageType && `${upperCamelCase(searchPageType)}Hits`, "DefaultHits"];
}
function HitsController(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "AlgoliaHitsController"
  });
  let {
    components = {},
    componentMapping = defaultComponentMapping,
    searchPageType,
    contentType,
    ...restProps
  } = props;
  const ownerState = {
    components,
    componentMapping,
    searchPageType,
    contentType,
    ...restProps
  };
  components = handleComponentsProp(components, {
    DefaultHits
    // SearchHits,
    // ArchiveHits,
  });
  let suggestedComponents = componentMapping(ownerState, defaultComponentMapping);
  suggestedComponents = [...ensureArray(suggestedComponents), ...ensureArray(defaultComponentMapping(ownerState))];
  suggestedComponents = suggestedComponents.map(Component2 => typeof Component2 === "string" ? components[Component2] : Component2);
  let Component = suggestedComponents.find(Boolean);
  if (!Component) {
    return /* @__PURE__ */jsx(DevNotice, {
      children: /* @__PURE__ */jsxs("details", {
        children: [/* @__PURE__ */jsx("summary", {
          children: `Could not map HitsController to a component`
        }), /* @__PURE__ */jsx("pre", {
          children: /* @__PURE__ */jsx("code", {
            children: JSON.stringify(ownerState, null, 2)
          })
        })]
      })
    });
  }
  return /* @__PURE__ */jsx(Component, {
    ...restProps,
    ownerState
  });
}
export { HitsController as default };